import { ChevronDown, Menu, PanelLeftClose, PanelLeftOpen, UserRound } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import Badge from '../ui/Badge.jsx'
import Button from '../ui/Button.jsx'
import { getInitials } from '../../utils/formatters.js'

export default function TopBar({ session, member, currentWorkspace, collapsed, onToggleCollapsed, onOpenMobile, onSignOut }) {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const triggerRef = useRef(null)

  useEffect(() => {
    if (!menuOpen) return undefined
    const close = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false)
        triggerRef.current?.focus()
      } else if (event.type === 'pointerdown' && !menuRef.current?.contains(event.target)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('keydown', close)
    document.addEventListener('pointerdown', close)
    return () => {
      document.removeEventListener('keydown', close)
      document.removeEventListener('pointerdown', close)
    }
  }, [menuOpen])

  const displayName = member.display_name || session.user.email
  return (
    <header className="topbar">
      <div className="topbar-controls">
        <Button variant="ghost" iconOnly className="mobile-menu-button" aria-label="Open navigation" onClick={onOpenMobile}><Menu aria-hidden="true" /></Button>
        <Button variant="ghost" iconOnly className="collapse-button" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} onClick={onToggleCollapsed}>
          {collapsed ? <PanelLeftOpen aria-hidden="true" /> : <PanelLeftClose aria-hidden="true" />}
        </Button>
        <span className="topbar-context"><strong>{currentWorkspace.label}</strong><small>{currentWorkspace.id === 'home' ? 'BFA workspace overview' : `${currentWorkspace.description} workspace`}</small></span>
      </div>
      <div className="account-control" ref={menuRef}>
        <button ref={triggerRef} type="button" className="account-trigger" aria-haspopup="menu" aria-expanded={menuOpen} onClick={() => setMenuOpen((value) => !value)}>
          <span className="avatar">{getInitials(member.display_name, session.user.email)}</span>
          <span className="account-copy"><strong>{displayName}</strong><span>{member.role}</span></span>
          <ChevronDown aria-hidden="true" />
        </button>
        {menuOpen && (
          <div className="account-menu" role="menu">
            <div className="account-menu-header"><span className="avatar avatar-large">{getInitials(member.display_name, session.user.email)}</span><div><strong>{displayName}</strong><span>{session.user.email}</span></div></div>
            <div className="account-menu-role"><UserRound aria-hidden="true" /><span>Botanical access</span><Badge tone="success">{member.role}</Badge></div>
            <button type="button" role="menuitem" onClick={onSignOut}>Sign out</button>
          </div>
        )}
      </div>
    </header>
  )
}
